import React, { useState, useEffect } from "react";

export default function ProfilePage() {
  const [editMode, setEditMode] = useState(false);

  const [form, setForm] = useState({
    first_name: "",
    last_name: "",
    gender: "",
    email: "",
    mobile: "",
  });

  const token = localStorage.getItem("access_token");

  // Load Profile
  useEffect(() => {
    fetch("https://hrgf.salepatner.com/api/profile/", {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((res) => res.json())
      .then((data) => {
        setForm({
          first_name: data.first_name || "",
          last_name: data.last_name || "",
          gender: data.gender || "",
          email: data.email || "",
          mobile: data.mobile || "",
        });
      });
  }, []);

  // Save Profile
  const saveProfile = () => {
    fetch("https://hrgf.salepatner.com/api/profile/update/", {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(form),
    })
      .then((res) => res.json())
      .then(() => {
        alert("Profile updated successfully!");
        setEditMode(false);
      })
      .catch(() => alert("Error updating profile"));
  };

  return (
    <div>
      {/* Header Title */}
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-xl font-semibold text-gray-900">
          Personal Information
        </h2>

        {!editMode && (
          <button
            onClick={() => setEditMode(true)}
            className="text-blue-600 text-sm font-medium hover:underline"
          >
            Edit
          </button>
        )}
      </div>

      {/* Name */}
      <div className="grid grid-cols-2 gap-6 mb-8">
        <input
          type="text"
          placeholder="First Name"
          disabled={!editMode}
          value={form.first_name}
          onChange={(e) => setForm({ ...form, first_name: e.target.value })}
          className={`border p-3 rounded-md w-full ${
            editMode ? "bg-white" : "bg-gray-100"
          }`}
        />

        <input
          type="text"
          placeholder="Last Name"
          disabled={!editMode}
          value={form.last_name}
          onChange={(e) => setForm({ ...form, last_name: e.target.value })}
          className={`border p-3 rounded-md w-full ${
            editMode ? "bg-white" : "bg-gray-100"
          }`}
        />
      </div>

      {/* Gender */}
      <div className="mb-6">
        <p className="text-gray-700 font-medium mb-3">Your Gender</p>

        <div className="flex gap-6">
          <label className="flex items-center gap-2 text-gray-600">
            <input
              type="radio"
              name="gender"
              disabled={!editMode}
              checked={form.gender === "male"}
              onChange={() => setForm({ ...form, gender: "male" })}
            />
            Male
          </label>

          <label className="flex items-center gap-2 text-gray-600">
            <input
              type="radio"
              name="gender"
              disabled={!editMode}
              checked={form.gender === "female"}
              onChange={() => setForm({ ...form, gender: "female" })}
            />
            Female
          </label>
        </div>
      </div>

      {/* Email */}
      <div className="mb-2">
        <h3 className="font-semibold text-gray-800">Email Address</h3>
      </div>

      <input
        type="email"
        placeholder="example@gmail.com"
        disabled={!editMode}
        value={form.email}
        onChange={(e) => setForm({ ...form, email: e.target.value })}
        className={`border p-3 rounded-md w-full mb-8 ${
          editMode ? "bg-white" : "bg-gray-100"
        }`}
      />

      {/* Mobile */}
      <div className="mb-2">
        <h3 className="font-semibold text-gray-800">Mobile Number</h3>
      </div>

      <input
        type="text"
        placeholder="9876543210"
        disabled={!editMode}
        value={form.mobile}
        onChange={(e) => setForm({ ...form, mobile: e.target.value })}
        className={`border p-3 rounded-md w-full mb-6 ${
          editMode ? "bg-white" : "bg-gray-100"
        }`}
      />

      {/* Save / Cancel */}
      {editMode && (
        <div className="flex gap-4 mt-4">
          <button
            onClick={saveProfile}
            className="bg-blue-600 text-white px-6 py-2 rounded-md"
          >
            Save
          </button>

          <button
            onClick={() => setEditMode(false)}
            className="px-6 py-2 rounded-md border text-gray-700"
          >
            Cancel
          </button>
        </div>
      )}
    </div>
  );
}
